<template>
    <div id="page">
        <div class="flex_b pad14" id="toolH">
            <div class="flex">
                <el-select style="width: 145px" @change="changetype"  class="" v-model="vc_type" size="small"  filterable >
                    <el-option
                            v-for="item in typeData"
                            :key="item.i_type"
                            :label="item.vc_type"
                            :value="item.i_type">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" @change="changeCom" @clear="clearsearch('gs')" class="" v-model="companyName" size="small" clearable filterable :placeholder="$t('saleOrder_please_select_a_trading_company')">
                    <el-option
                            v-for="item in compsData"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
                <el-date-picker
                        style="width: 220px"
                        class="marr4"
                        size="small"
                        v-model="valuetime"
                        @change="getTimes"
                        :clearable="false"
                        type="daterange"
                        :range-separator="$t('form_to')"
                        :start-placeholder="$t('form_start_date')"
                        :end-placeholder="$t('form_end_date')">
                </el-date-picker>

                <el-input  @clear="clearsearch('sou')"  class="marr4" style="width: 195px"  v-model="vc_search" :placeholder="$t('saleOrder_please_search_by_contact_id/customer_name/product/salesperson')" clearable size="small"></el-input>
                <el-button  icon="el-icon-search" circle  size="mini" @click="gosearch"></el-button>

            </div>
            <div class="flex">
<!--                <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="addTd">{{$t('saleOrder_add_bill_of_lading')}}</el-button>-->
                <el-button :class="baseerp+'btn'" size="small" type="primary" plain @click="output">{{$t('button_export')}}</el-button>
            </div>
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="i_plxdid"
                    :label="$t('saleOrder_contact_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="i_ispresale"
                    :label="$t('saleOrder_sales_status')"
                    width="80px"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="boxyu box" v-if="scope.row.i_istemp==1">{{$t('form_face')}}</div>
                    <div class="boxyu box marr5" v-else-if="scope.row.i_isdirect==1">{{$t('form_direct')}}</div>
                    <div class="boxyu box" v-else-if="scope.row.i_ispresale==1">{{$t('form_pre')}}</div>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    :label="$t('form_sales_number')"
                    width="170px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_ckname"
                    :label="$t('form_warehouse')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="i_type"
                    :label="$t('saleOrder_order_modification')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
<!--                    <span :class="baseerp+'color'" style="display: block" v-for="(item,index) in scope.row.list" :key="index">{{item.i_type==0?"-":(item.i_type==1?"途损":(item.i_type==2?"部分退回":(item.i_type==3?"调整误差":(item.i_type==4?"调整单价":(item.i_type==5?"全部退单":'减少发货')))))}}</span>-->
                    <span :class="baseerp+'color'" style="display: block" >{{scope.row.i_type==0?"":(scope.row.i_type==1?"途损":(scope.row.i_type==2?"部分退回":(scope.row.i_type==3?"调整误差":(scope.row.i_type==4?"调整单价":(scope.row.i_type==5?"全部退单":'减少发货')))))}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_variety')"
                    width="190px"
                    show-overflow-tooltip>
                <!--<template slot-scope="scope">
                    <span style="display: block" v-for="(item,index) in scope.row.list" :key="index">{{item.vc_pzname}}</span>
                </template>-->
            </el-table-column>
            <el-table-column
                    prop="vc_jno"
                    :label="$t('form_batch_number')"
                    width="150px"
                    show-overflow-tooltip>
                <!--<template slot-scope="scope">
                    <span style="display: block" v-for="(item,index) in scope.row.list" :key="index">{{item.vc_jno}}</span>
                </template>-->
            </el-table-column>
            <el-table-column
                    prop="vc_bz_ename"
                    :label="$t('form_currency')"
                    width="50px"
                    show-overflow-tooltip>
                <!--<template slot-scope="scope">
                    <span style="display: block" v-for="(item,index) in scope.row.list" :key="index">{{item.vc_bz_ename}}</span>
                </template>-->
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('form_quantity')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="display: block;text-align: right;" >{{scope.row.f_num}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_price"
                    :label="$t('form_unit_price')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="display: block;text-align: right;" >{{scope.row.f_price}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_ckname"
                    :label="$t('form_amount')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="display: block;text-align: right;" >{{!scope.row.f_num?0:(Math.round(scope.row.f_num * scope.row.f_price * 100) / 100)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="dt_yjdhtime"
                    :label="$t('saleOrder_expected_delivery_time')"
                    width="130px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_yjdptime"
                    :label="$t('saleOrder_pre_arrival_ticket_time')"
                    width="130px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_yjfktime"
                    :label="$t('saleOrder_advance_payment_time')"
                    width="130px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_payway"
                    :label="$t('saleOrder_payment_method')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_sendway"
                    :label="$t('saleOrder_delivery_method')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    :label="$t('form_trading_company')"
                    width="130px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    :label="$t('form_pustomer')"
                    width="180px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_hqgsname"
                    :label="$t('form_goods_rights_company')"
                    width="130px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kduname"
                    :label="$t('form_business')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    :label="$t('form_input_person')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    :label="$t('form_enter_time')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_note"
                    :label="$t('form_notes')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_xcode_relate"
                    :label="$t('saleOrder_associated_sales_order_number')"
                    show-overflow-tooltip
                    width="110px">
            </el-table-column>
            <el-table-column
                    prop="vc_ghcname_relate"
                    :label="$t('saleOrder_related_sales_companies')"
                    show-overflow-tooltip
                    width="110px">
            </el-table-column>
            <el-table-column
                    width="180"
                    fixed="right"
                    :label="$t('form_operate')">
                <template slot-scope="scope">
<!--                    <el-button v-if="i_type==0"  type="text" size="small" @click="editClick(scope.row)">{{$t('button_edit')}}</el-button>-->
<!--                    <el-button v-if="i_type==1"   type="text" size="small" @click="editClick(scope.row)">{{$t('button_review')}}</el-button>-->
                    <el-button  type="text" size="small" @click="goLxd(scope.row)">{{$t('saleOrder_view_contact_form')}}</el-button>
                    <el-button  type="text" size="small" @click="goCost(scope.row)">{{$t('purchaseOrder_check_the_fees')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                :class="baseerp+'div'"
                top="5vh"
                width="90%"
                :title="$t('purchaseOrder_cost_breakdown')"
                :visible.sync="dialogVisible_cost"
                :close-on-click-modal="false"
                @close="cancelDialog('cost')"
                v-if="dialogVisible_cost"
                :append-to-body="true">
            <cost-list ref="costlist" :Data="rowData" @close="cancelDialog('cost')"></cost-list>
        </el-dialog>
    </div>
</template>



<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import costList from '../purchaseOrder/costList';
    export default {
        components: {
            costList,
        },
        data() {
            return {
                rowData:{},
                maxDialogHeight:0,
                dialogVisible_cost:false,
                baseerp:"",
                mid:0,
                loading:true,
                tableHeight:0,
                typeData:[
                    {i_type:0,vc_type:this.$t('state_all')},
                    {i_type:1,vc_type:this.$t('saleOrder_temporary_order_unaudited')},
                ],
                i_type:0,
                vc_type:this.$t('state_all'),
                compsData:[],
                companyName:'',
                companyId:0,
                vc_search:"",
                tableData:[],
                highlightCurrentRow:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.getfMou();
            this.getCompanyList();
            //this.getList(1);
            this.$nextTick(function () {
                this.onResize();
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                //console.log(n.h,this.tableHeight)
            },
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
                //const otherHeight =230;
                //this.tableHeight = window.innerHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
            },
            output(){
                let map={
                    i_gsid:this.companyId,
                    dt_startdate:this.dt_startdate,
                    dt_enddate:this.dt_enddate,
                    vc_search:this.vc_search,
                };
                this.$emit("outputdata",map);
            },
            addTd(){
              this.$emit('openTree')
            },
            //关闭dialog
            cancelDialog(type){
                //console.log("guanleeeeeeeeeeeeeeeeeeeee")
                if(type=="cost"){
                    this.rowData={};
                    this.dialogVisible_cost=false;
                }
            },
            goCost(row){
                this.dialogVisible_cost=true;
                this.rowData={
                    type:'sale',
                    row:row,
                };
            },
            goLxd(row){
                //console.log(row)
                this.$emit('getListid',row,'editLXD')
            },
            editClick(row){
                //console.log(row);
                if(this.i_type==0){
                    this.$emit('getListid',row,'TD')
                }else{
                    this.$emit('getListid',row,'LSD')
                }

            },
            //获取交易公司
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                //console.log(this.mid,'this.mid!!!!!!!!!')
                let param = {
                    vc_search:'',
                    page_count:1,
                    page_size:999,
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changetype(e){
                this.i_type=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList(1);
            },
            changeCom(e){
                //console.log(e);
                this.companyId=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList(1);
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList(1);
            },
            clearsearch(type){
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";

                }else if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList(1);
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList(1);
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList(1);
            },
            //列表list
            async getList(type){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    "i_gsid": this.companyId,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    'i_type':this.i_type,
                };
                //console.log('调接口',type,this.vc_search,this.companyId);
                //return;
                if(type==0){
                    var res = await API.getLxdList(param);
                }else if(type==1){
                    var res = await API.listTd(param);
                }
                if (res.code==1){
                    /*res.data.list.map(item=>{
                        let hush=[];
                        hush.push(item.list[0]);
                        item.showpzlist=hush;
                        item.pzlen=item.list.length;
                    })*/
                    this.tableData=res.data;
                    this.tableTotal=res.total;
                    this.loading=false;
                    this.setDialogHeight();
                    window.addEventListener('resize', this.setDialogHeight);

                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList(1);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList(1);
            },
        },
    }
</script>

<style  lang="scss" scoped>
    /*/deep/.el-table td {*/
    /*    text-align: unset !important;*/

    /*}*/
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>